import { Component, OnInit } from "@angular/core";
import { DownloadService } from "../base/services/download.service";
import { FileLoaderService } from "../services/file-loader.service";

@Component({
  selector: "app-election-2024",
  templateUrl: "./election-2024.component.html",
  styleUrls: ["./election-2024.component.scss"],
})
export class Election2024Component {}
